/// <amd-module name="typeahead/core/IListItem"/>
export enum ListItemType {Label, Suggestion}

export interface IListItem {
    listItemType: ListItemType;
}

export class LabelTypeListItem implements IListItem {

    public readonly listItemType: ListItemType = ListItemType.Label;
    // Parameter property declaration : "type" of param is called the accessibility of property member
    constructor (public html: string) {}
}
